import {
  USER_STATUS_CHANGED_SUCCESS,
  USER_STATUS_CHANGED_FAILURE,
} from "../types/index";

const defaultState = {
  user: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USER_STATUS_CHANGED_SUCCESS:
      console.log("Inside user reducer", action.payload);

      return {
        ...state,
        user: action.payload,
      };

    default:
      return state;
  }
};
